import { Observable } from '../Observable';
import { noop } from '../util/noop';
export var NEVER = new Observable(noop);
export function never() {
    return NEVER;
}
//# sourceMappingURL=never.js.map